import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import CachedAvatar from "./CachedAvatar";

const ClickableParticipant = ({ id, onClick }) => {
    const [user, loading, error] = useDocumentData(doc(db, 'users', id));

    if (loading) return (<div></div>)
    if (error) return (<div>bad id</div>)

    return (
        <div className="participant" onClick={onClick}>
            <CachedAvatar src={user.image} alt={user.title} />
            <span>{user.title}</span>
        </div>
    )
}

export default ClickableParticipant;
